import * as React from "react";

function SvgGoedle(props, ref) {
  return (
    <svg
      id="Goedle_svg__Ebene_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 661.3 595"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".Goedle_svg__st0{fill:#343434}"}</style>
      <path
        className="Goedle_svg__st0"
        d="M395.4 517.2h.5-.5zM342.7 192.1c-28 24.1-31.2 66.4-7 94.5 18.6 21.6 48.1 28.4 73.4 19.3l37.8 6.8-1.6-37.8c12.9-23.7 10.6-54-8.1-75.7-24.2-28.1-66.5-31.2-94.5-7.1z"
      />
      <path
        className="Goedle_svg__st0"
        d="M87 44.2v498h498v-498H87zm433.7 301.1c0 34 0 61.3-20.1 87.6-23 29.7-56.5 45.4-100.2 47.2H151.3v-73.9H401.6c29.2-1.5 45.7-12 45.7-48.4 0-4.3 0-8.7-.5-13-21.1 19.1-42 28.2-68.8 28.2-35.8 0-67.1-15.3-88.9-40.4H151.3v-74.5h106.5c-.6-5.2-.9-10.8-.9-16.3 0-20.4 4.1-39.7 12.2-57.2H151.3v-73.9h227.2c29.7 0 51.6 11 68.3 32.6v-28.9h73.9v230.9z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgGoedle);
